module.exports = __webpack_public_path__ + "img/hohlschnitt_moosgruen_ral6005.fae864c2.jpg";